import { memo } from 'react'

import { ButtonImage } from '@/components/common/Button'
import { LoadingMask } from '@/components/common/LoadingMask'

import styles from './TagsListItem.module.scss'

type Props = {
  count: number
  href?: string
  image?: string
  label: string
  loading?: boolean
}

const TagsListItemInner = ({ count, href, image, label, loading }: Props) => (
  <li className={styles.container}>
    <ButtonImage as='LinkRoute' count={count} href={href} image={image} label='decks' nowrap size='lg'>
      {label}
    </ButtonImage>
    <LoadingMask allowClicks bgNone loading={loading} />
  </li>
)

export const TagsListItem = memo(TagsListItemInner)
